<template>
  <span class="XK-input">
     <input v-if="type=='number'"
            type="number"
            :placeholder="placeholder"
            v-model="val"
            ref="input"
            autofocus="autofocus"
            @blur="blurFn"
            @change="changeFn"
            @input="inputFn"/>
     <input v-else-if="type=='text'"
            type="number"
            :placeholder="placeholder"
            v-model="val"
            ref="input"
            autofocus="autofocus"
            @blur="blurFn"
            @change="changeFn"
            @input="inputFn"/>
     <input v-else
            type="number"
            :placeholder="placeholder"
            v-model="val"
            ref="input"
            autofocus="autofocus"
            @blur="blurFn"
            @change="changeFn"
            @input="inputFn"/>
    <div class="closeButDiv" @click="closeFn">
      <span class="closeBut"><i class="iconfont icon-iconfontclosesmall"></i></span>
    </div>

  </span>

</template>

<script>
  export default {
    name: 'xk-input',
    props: ['placeholder', 'data', 'focus', 'type'],
    data () {
      return {
        val: ''
      }
    },
    methods: {
      blurFn: function () { // 失去焦点
        this.$emit('blur', {
          that: this,
          val: this.val
        })
      },
      changeFn: function () { // change
        this.$emit('change', {
          that: this,
          val: this.val
        })
      },
      inputFn: function () { // input
        this.$emit('change', {
          that: this,
          val: this.val
        })
      },
      closeFn: function () {
        if (this.val !== '') {
          this.val = ''
          this.$emit('close', {
            that: this,
            val: this.val
          })
        } else {
          this.$emit('close', {
            that: this,
            val: this.val
          })
        }
      }
    },
    mounted: function () {
      let that = this
      if (that.focus) {
        that.$refs.input.click()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .XK-input {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    position: relative;
    padding: 0 0.5rem;
    .closeButDiv {
      right: 0;
      height: 100%;
      width: 1.5rem;
      top: 0;
      position: absolute;
      .closeBut {
        position: absolute;
        background-color: #ddd;
        right: 0.8rem;
        top: 50%;
        transform: translate(0, -50%);
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        i {
          position: absolute;
          font-size: 0.4rem !important;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
        }
      }
    }
    input {
      height: 100%;
      box-sizing: border-box;
      line-height: 1;
      width: 100%;
      padding-right: 1.5rem;
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// input.vue?de5696fe